import React from "react";
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom'

import {getAvailableProducts, isMenuOpen} from "state/app/selectors";
import { isAppserverOnline, isProductAvailable } from "lib/validate";
import {openURL} from "state/app/actions";
import warningIcon from "components/assets/images/app-warning.svg";
import "components/app/MainMenu.css";

// Assign each menu item a unique ID, for React key parameter-ing
// This data is totally static, so it belongs here, rather than in state
const availableProductsMenuItems = {
    teachers: [
      {title:"Messages",      path:"/teachers/messages/"     },
      {title:"Noticeboard",   path:"/teachers/noticeboard/"  },
      {title:"Term Calendar", path:"/teachers/term_calendar/"}
    ],
    school_money: [
      {title: "Payments", path:"/school_money/payments/"},
      {title: "Dinners", path:"/school_money/dinners/"},
      {title: "Clubs", path:"/school_money/clubs/"},
      {title: "Shop", path:"/school_money/shop/"},
      {title: "Parental Consent", path: "/school_money/parental_consent/" },
      {title: "History", path:"/school_money/history/"}
    ]
};

// Render an entire menu section based on the product name
// Uses the availableProductsMenuItems

/**
 * getProductMenuSection - get the menu section element for a given productName
 *
 * @param  {String} productName
 * @returns {type}             description
 */
function getProductMenuSection(productName) {
  let productItems = availableProductsMenuItems[productName];

  // Bad product name - no section to render
  // consider throw error here, as it means we are trying to draw an app we don't support
  if (productItems === undefined) {
    return null;
  }
  return <div className={`main-menu__section main-menu__section--${productName}`} >
    <div className={`main-menu__accent main-menu__accent--${productName}`}></div>
    {
      productItems.map( (item, index) => (
        <NavLink key={`${productName}_${index}`} to={item.path} className={`main-menu__item main-menu__item--${productName}`} activeClassName={`main-menu__item--${productName}--selected`}>{item.title}</NavLink>
      ))
    }
    </div>
}

/**
 * Main Menu - Uses a static list of menu items which are displayed as Navlinks
 * @constructor
 */
class MainMenu extends React.Component {

  openPaymentSecurityInfoLink = (clickEvent) => {
    clickEvent.stopPropagation();
    const onlinePaymentSecurityLink = "https://eduspot.co.uk/online-payments-security/";
    this.props.openURL( onlinePaymentSecurityLink );
  }

  getOnlinePaymentSecurityLink = () => {
    const onlinePaymentSecuritySectionTitle = "Important Notice regarding Online Payment Security";
    // React router dom will not support opening a new link, so we add in link manually
    return (
        <div className="main-menu__item--payment_security_link_container">
            <span className="main-menu__item" key="payment_security_link" onClick={this.openPaymentSecurityInfoLink}>
              <div className="main-menu__item--payment_security_link_icon_container"><img className="main-menu__item--payment_security_link_icon" src={warningIcon} alt="" /></div>
              <div className="main-menu__item--payment_security_link_label">{onlinePaymentSecuritySectionTitle}</div>
            </span>
        </div>
      );
  }

  render() {
    const menuClassName = `main-menu ${ this.props.isMenuOpen ? "main-menu--open" : "" }`;

    return (
      <div className={menuClassName}>
        <div className="main-menu__body">
          <div className="main-menu__section-container">
            {this.props.availableProducts.includes("teachers") && isProductAvailable("teachers") && isAppserverOnline() ? getProductMenuSection("teachers") : null}
            {this.props.availableProducts.includes("school_money") && isProductAvailable("school_money") && isAppserverOnline() ? getProductMenuSection("school_money") : null}
            {this.props.availableProducts.includes("school_money") && isProductAvailable("school_money") && isAppserverOnline() ? this.getOnlinePaymentSecurityLink() : null}
          </div>
          <div className="main-menu__hr-container"><div className="main-menu__hr"></div></div>
          <NavLink to="/help/" className="main-menu__help" activeClassName="main-menu__help--selected">Help</NavLink>
        </div>
      </div>
    );
  }
}


export default connect(
  // props
  (state) => ({
    availableProducts: getAvailableProducts(state),
    isMenuOpen:        isMenuOpen(state)
  }),
  {openURL}
)(MainMenu);



// WEBPACK FOOTER //
// ./src/components/app/MainMenu.js